import React, { useContext, useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player';

const AudioPlayerContext = React.createContext(undefined);

const AudioPlayerProvider = ({ children, src }) => {
    const player = useRef();
    const [mute, setMute] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [playbackRate, setPlaybackRate] = useState(1.0);
    const [volumeCollapse, setVolumeCollapse] = useState(false);

    const [played, setPlayed] = useState(0);
    const [volume, setVolume] = useState(1);

    const [duration, setDuration] = useState(false);

    useEffect(() => {
        const percentage = (volume * 100).toFixed(2);
        document?.documentElement?.style?.setProperty(
            '--volumeSlider',
            `#ffffff ${percentage}%, #9da9bf ${percentage}% 100%`
        );
    }, [volume]);

    useEffect(() => {
        const percentage = (played * 100).toFixed(2);
        document?.documentElement?.style?.setProperty(
            '--progressSlider',
            `#ffffff ${percentage}%, #9da9bf ${percentage}% 100%`
        );
    }, [played]);

    const onPlayClick = () => {
        setPlaying(!playing);
    };

    const handleDuration = (dur) => {
        setDuration(dur);
    };

    const handleSeekChange = (e) => {
        setPlayed(parseFloat(e.target.value));
    };

    const handleSeekMouseUp = (e) => {
        player?.current?.seekTo(parseFloat(e.target.value));
    };

    const handleProgress = (_state) => {
        setPlayed(_state?.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleMute = () => {
        setMute(!mute);
    };

    return (
        <AudioPlayerContext.Provider
            value={{
                played,
                playing,
                duration,
                volume,
                volumeCollapse,
                mute,
                src,
                playbackRate,
                setPlaybackRate,
                handleMute,
                setVolumeCollapse,
                onPlayClick,
                handleSeekChange,
                handleSeekMouseUp,
                handleVolumeChange,
            }}
        >
            <ReactPlayer
                className="react-player"
                ref={player}
                width="0px"
                height="0px"
                url={src}
                playing={playing}
                playbackRate={playbackRate}
                volume={volume}
                muted={mute}
                onProgress={handleProgress}
                onDuration={handleDuration}
            />
            {children}
        </AudioPlayerContext.Provider>
    );
};

const useAudioPlayer = () => {
    const context = useContext(AudioPlayerContext);
    if (context === undefined) {
        throw new Error(
            'useAudioPlayer can only be used inside AudioPlayerProvider'
        );
    }
    return context;
};

export { AudioPlayerProvider, useAudioPlayer };
